/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { useNavigate } from "react-router-dom";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { cartFlowSequence } from "../miscellaneous/cartFlowSequence";
import { useLanguageUrlParam } from "./useLanguageUrlParam";

export function useNavigateToIndex() {
  const navigate = useNavigate();
  const langUrlParam = useLanguageUrlParam();

  function go(route: unknown) {
    navigate(`${getPartnerPathnameClient(true)}${route}`);
    return null;
  }

  return function navigateToIndex(index: number) {
    const next = cartFlowSequence[index];

    if (next?.path === undefined) {
      throw new Error("no matching page");
    } else {
      return go(`${next.path}${next.hash}${langUrlParam}`);
    }
  };
}
